'use client';

import { useState } from 'react';

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
} from '@/ui';
import { cn } from '@lib';
import { SelectValue } from '@radix-ui/react-select';
import { format } from 'date-fns';
import { UseFormReturn } from 'react-hook-form';

export const DateOfBirthField = ({ form }: { form: UseFormReturn }) => {
  const [dirty, setDirty] = useState<{ [key: string]: boolean }>({
    day: false,
    month: false,
    year: false,
  });
  return (
    <FormField
      key={'BirthDate'}
      name="BirthDate"
      control={form.control}
      render={({ field }) => (
        <FormItem>
          <FormLabel>Date of Birth *</FormLabel>
          <div className="flex gap-2">
            {[
              {
                name: 'day',
                placeholder: 'Day',
                label: (day: string) => day,
                array: Array.from({ length: 31 }, (_, i) => i + 1),
                value: field.value?.getDate(),
                onChange: (e: string) => {
                  setDirty({ ...dirty, day: true });
                  return field.onChange(
                    new Date(field.value?.getFullYear() || 0, field.value?.getMonth() || 0, parseInt(e, 10)),
                  );
                },
              },
              {
                name: 'month',
                placeholder: 'Month',
                label: (month: string) => format(new Date(0, parseInt(month, 10)), 'MMMM'),
                array: Array.from({ length: 12 }, (_, i) => i),
                value: field.value?.getMonth(),
                onChange: (e: string) => {
                  setDirty({ ...dirty, month: true });
                  field.onChange(
                    new Date(field.value?.getFullYear() || 0, parseInt(e, 10), field.value?.getDate() || 0),
                  );
                },
              },
              {
                name: 'year',
                placeholder: 'Year',
                label: (year: string) => year,
                array: Array.from({ length: 120 }, (_, i) => new Date().getFullYear() - i - 17),
                value: field.value?.getFullYear(),
                onChange: (e: string) => {
                  setDirty({ ...dirty, year: true });
                  field.onChange(new Date(parseInt(e, 10), field.value?.getMonth() || 0, field.value?.getDate() || 0));
                },
              },
            ].map(({ name, placeholder, label, array, value, onChange }) => (
              <FormControl key={name}>
                <Select value={dirty[name] && value ? value.toString() : ''} onValueChange={(e) => onChange(e)}>
                  <SelectTrigger className={cn(!field.value && 'text-muted-foreground')}>
                    <SelectValue placeholder={placeholder} />
                  </SelectTrigger>
                  <SelectContent>
                    {array.map((item) => (
                      <SelectItem key={item} value={String(item)}>
                        {label(String(item))}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </FormControl>
            ))}
          </div>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
